var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "limits-table" }, [
    _c(
      "table",
      _vm._l(_vm.items, function(item) {
        return _c("tr", { key: item.id }, [
          _c("td", [
            _c(
              "span",
              {
                staticClass:
                  "limits-table__title typographies-paragraph-medium-semibold"
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(item.title) +
                    "\n                "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "limits-table__description typographies-paragraph-small-regular"
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(item.description) +
                    "\n                "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "typographies-paragraph-medium-regular" }, [
            _c(
              "div",
              { staticClass: "limits-used" },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.formatNumericValue(item.used, item) +
                        " / " +
                        _vm.formatNumericValue(
                          item.limit,
                          item,
                          [
                            "file_storage",
                            "document_invoices",
                            "bank_account_reconciliations"
                          ],
                          true
                        )
                    ) +
                    "\n                    "
                ),
                item.id === "document_invoices"
                  ? _c(
                      "CompassTooltip",
                      [
                        _c("template", { slot: "content" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$l10n.__("Remise à zéro le ")) +
                              "\n                            " +
                              _vm._s(_vm.invoicingLimitResetDate) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("CompassIcon", {
                          staticClass: "info-icon",
                          attrs: { size: "small", icon: "info-circle-fill" }
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _vm.displayTag(item)
                ? _c(
                    "CompassTag",
                    {
                      attrs: {
                        type: "colored",
                        size: "small",
                        color: _vm.displayTag(item)
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.tagLabel(item)) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("td", [
            _c("span", { class: _vm.remainderClass(item) }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$l10n.n__(
                      "%(rest)s restant",
                      "%(rest)s restants",
                      _vm.remainingItems(item),
                      {
                        rest: _vm.formatNumericValue(
                          _vm.remainingItems(item),
                          item,
                          ["file_storage"]
                        )
                      }
                    )
                  ) +
                  "\n                "
              )
            ])
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }